import * as _ from 'lodash';
import * as moment from 'moment';
import { Injectable } from '@angular/core';
import { InitialDataService } from 'app/initial-data.service';


@Injectable()
export class GxUtilsService {

    constructor(private initialDataService: InitialDataService) { }
    removeDashesAndCapitalizeAfter(str: string) {
        return str.replace(/(-.)/g, function (x) { return x[1].toUpperCase() });
    }
    camelCaseToHuman = (input) => {
        return (input || '')
            // insert a space before all caps
            .replace(/([A-Z])/g, ' $1')
            // uppercase the first character
            .replace(/^./, str => str.toUpperCase());
    };
    calculateDistance = (lat1, lon1, lat2, lon2) => {
        var rlat1 = Math.PI * lat1 / 180,
            rlat2 = Math.PI * lat2 / 180,
            theta = lon1 - lon2,
            rtheta = Math.PI * theta / 180,
            dist = Math.sin(rlat1) * Math.sin(rlat2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.cos(rtheta);

        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        // I quickly converted miles to km. Still not correct, maybe need to use google api to calculate actual walking/road distance?
        dist = dist * 1.6;
        return dist;
    };
    getXPath = (element) => {
        var xpath = '';
        for (; element && element.nodeType === 1; element = element.parentNode) {
            const id = $(element.parentNode).children(element.tagName).index(element) + 1;
            let idString = '';;
            if (id > 1) {
                idString = `[${id}]`;
            }
            xpath = '/' + element.tagName.toLowerCase() + idString + xpath;
        }
        return xpath;
    };

    //server date comes like this: '2016-11-04T00:00:00'.
    //Result is converted to '04-Nov-2016'.
    fromServerDate = (serverDate: string, format?: string) => {
        if (!!format) {
            return moment(serverDate, format).format('DD-MMM-YYYY');
        } else {
            return moment(serverDate).format('DD-MMM-YYYY');
        }
    };

    //drop $scope functions/angular-specific vars
    cleanObject = (obj) => {
        return _.cloneDeep(obj);
    };

    //Coverts string date to jscript date'.
    //Result is converted to '04-Nov-2016'.
    fromServerTextDate = (serverDate) => {
        const strSplitDate = serverDate.split('/', 3),
            [day, month] = strSplitDate,
            year = strSplitDate[2].substring(0, 4),
            [time] = serverDate.split(' ', 3),
            [hh, mm, ss] = time.split(':', 3),

            dateOut = new Date(year, month - 1, day, hh, mm, ss);
        return dateOut;
    };


    //Coverts string date to jscript date'.
    //Result is converted to '04-Nov-2016'.
    fromServerTextDateMonth = (serverDate) => {

        var monthNames = [
            'Jan', 'Feb', 'Mar',
            'Apr', 'May', 'Jun', 'Jul',
            'Aug', 'Sep', 'Oct',
            'Nov', 'Dec'
        ];


        var strSplitDate = serverDate.split('/', 3),
            day = strSplitDate[0],
            month = strSplitDate[1],
            year = strSplitDate[2].substring(0, 4);
        return day + '-' + monthNames[month - 1] + '-' + year;
    };
}



// WEBPACK FOOTER //
// ./src/app/shared/services/gx-utils.service.ts